<template>
  <div id="nav" class="nav bg1" :class="{'nav-for-homepage': this.$store.state.homeScrollY < 20 && this.$route.path == '/'}">
    <div class="nav-main">
<!--      <router-link to="/">-->
<!--        <img :src="logo" alt="#" class="logo" />-->
<!--      </router-link>-->
<!--      <router-link to="/">-->
<!--        首页-->
<!--      </router-link>-->
<!--      <router-link to="/download">-->
<!--        产品-->
<!--      </router-link>-->

      <a @click="goClick('/','首页')" href="javascript:;" :class="{'router-link-exact-active':this.$route.path=='/','nav-for-homepage-a':true}">
        <img v-if="this.$store.state.homeScrollY < 20 && this.$route.path == '/'" :src="logoWhite" alt="#" class="logo" />
        <img v-else :src="logo" alt="#" class="logo" />
      </a>
      <a @click="goClick('/','首页')" href="javascript:;" :class="{'router-link-exact-active':this.$route.path=='/','nav-for-homepage-a':true}">
        首页
      </a>
      <div
        class="nav-drop"
        @mouseenter="dropOpen = true"
        @mouseleave="dropOpen = false"
      >
        <a class="nav-drop-link" href="javascript:;" :class="{'router-link-exact-active': isScenePage, 'nav-for-homepage-a': true}">
          场景功能
          <svg class="nav-drop-tri" width="10" height="6" viewBox="0 0 10 6" fill="none">
            <path d="M1 1l4 4 4-4" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </a>
        <div class="nav-drop-panel" v-show="dropOpen">
          <div
            class="nav-drop-item"
            v-for="item in scenePages"
            :key="item.path"
            @click="goScene(item)"
            :class="{ 'nav-drop-item-active': $route.path === item.path }"
          >
            {{ item.name }}
          </div>
        </div>
      </div>
      <a @click="goClick('/download','下载')" href="javascript:;" :class="{'router-link-exact-active':this.$route.path=='/download','nav-for-homepage-a':true}">
        下载
      </a>
        <a @click="goClick('/pricing','定价')" href="javascript:;" :class="{'router-link-exact-active':this.$route.path=='/pricing','nav-for-homepage-a':true}">
            定价
        </a>

        <!-- <a @click="goClick('/singin','惺灵')" href="javascript:;" :class="{'router-link-exact-active':this.$route.path=='/singin','nav-for-homepage-a':true}">
            惺灵
        </a> -->

      <a @click="goHelp" href="javascript:;" class="nav-for-homepage-a" :class="{'router-link-exact-active':this.$route.path=='/service'}">
        帮助中心
      </a>
      <a @click="goNews" href="javascript:;" class="nav-for-homepage-a" :class="{'router-link-exact-active':this.$route.path.indexOf('/news')==0}">
        资讯
      </a>

<!--      <router-link to="/about">关于我们</router-link>-->
<!--      <a class="download" @click="goHelp" href="javascript:;">帮助中心</a>-->
<!--      <a class="download" @click="goNews" href="javascript:;"> 资讯 </a>-->
<!--      <router-link to="/download"> 下载 </router-link>-->
<!--      <router-link to="/business" class="second-nav"> 购买 </router-link>-->
<!--      <router-link to="/" class="second-nav"> 首页 </router-link>-->

        <a class="download-btn" @click="goClick('https://yc.iepose.com/jdxb_console/','小宝控制台')" target="_blank">
            进入控制台
        </a>
        <!--<a class="console-btn" @click="goClick('https://yc.iepose.com/jdxb_console/','小宝控制台')" target="_blank">
            控制台
        </a>-->
        <!-- <a class="console-btn nav-for-homepage-a" @click="goClick('https://yc.iepose.com/task','工单')" target="_blank">
            工单
        </a> -->

    </div>
  </div>
</template>

<script>
import {mapActions} from "vuex";

export default {
  name: "Nav",
  data: function () {
    return {
      logo: require("../assets/v5/logo.svg"),
      logoWhite: require("../assets/v5/logo_white.svg"),
      bg: "",
      dropOpen: false,
      scenePages: [
        {
          path: "/introduce/tunNetwork",
          name: "异地组网",
        },
        {
          path: "/introduce/nat",
          name: "内网穿透",
        },
        {
          path: "/introduce/shareNetwork",
          name: "共享网络",
        },
        // 暂时屏蔽「远程桌面」介绍页入口（产品决策），恢复时放开下面 3 行即可
        // {
        //   path: "/introduce/remoteDesktop",
        //   name: "远程桌面",
        // },
        {
          path: "/introduce/remoteFiles",
          name: "远程文件",
        },
        {
          path: "/introduce/albumBackup",
          name: "相册备份",
        },
      ],
    };
  },
  computed: {
    isScenePage: function () {
      return this.$route.path.indexOf("/introduce") === 0;
    },
  },
  props: {},
  methods: {
    ...mapActions([
      "sendLog"
    ]),
    goDownload:function(data){
        if(this.$route.path != data){
            this.$router.push(data);
        }
        this.sendLog(["PC_nav_clicked","开始使用"]);
    },
    goClick:function(data,type){
      if(data.includes("//")) {
        window.open(this.$store.getters.rebuildUrl(data));
      }else if(this.$route.path != data){
            this.$router.push(data);
            this.sendLog(["PC_nav_clicked",type]);
        }
    },
    goHelp: function () {
      this.sendLog(["PC_nav_clicked","文档"]);
        if(process.env.NODE_ENV == 'development'){
            this.$router.push("/service");
        }else{
            this.$router.push("/service");
        }

    },
    goNews: function () {
      this.$router.push("/news");
    },
    goScene: function (item) {
      this.dropOpen = false;
      this.sendLog(["PC_nav_clicked", item.name]);
      if (this.$route.path !== item.path) {
        this.$router.push(item.path);
      }
    },
  },
  mounted() {
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
.nav {
  position: fixed;
  top: 0;
  height: 70px;
  width: 100%;
  z-index: 9;
  border-bottom: 1px solid #e8eaf3;
  box-sizing: border-box;
  background: rgba(255, 255, 255, 0.75);
  backdrop-filter: blur(15px);

  .nav-main {
    margin: 0 auto;
    width: 1280px;
  }
  .nav-main:after {
    content: "";
    display: block; /* 设置添加子元素为块级元素 */
    height: 0; /* 设置添加的子元素的高度0 */
    visibility: hidden; /* 设置添加子元素看不见 */
    clear: both; /* 设置clear：both */
  }

  a {
    float: left;
    padding-left: 26px;
    padding-right: 26px;
    font-size: 16px;
    color: #1D1F24;
    text-decoration: none;
    height: 70px;
    line-height: 70px;
    vertical-align: top;
    cursor: pointer;
  }
  a:hover {
    color: #3772FF;
  }
  a.router-link-exact-active {
    color: #3772FF;
  }

  /* ---------- 场景功能下拉 ---------- */
  .nav-drop {
    position: relative;
    float: left;
    // 容器收缩宽度比链接内容多出 20px 空位，右移负 margin 补偿，让「下载」对齐统一 52px 间距
    margin-right: -20px;
    height: 70px;
    line-height: 70px;

    .nav-drop-link {
      float: none;
      display: inline-flex;
      align-items: center;
      height: 70px;
      line-height: 70px;
      padding-left: 26px;
      // 右侧留白 12px（26-14=12，14 为箭头宽+间隙）：箭头紧跟文字，同时项总宽不变，与其它按钮间距保持统一
      padding-right: 12px;
      color: #1D1F24;

      // 箭头紧跟文字（与文字间隙 4px，不额外撑开与「下载」的间距）
      svg {
        margin-left: 4px;
        transition: transform 0.2s;
      }

      &:hover {
        color: #3772FF;
      }
    }

    .nav-drop-panel {
      position: absolute;
      top: 70px;
      left: 26px;
      min-width: 176px;
      padding: 6px 0;
      background: #ffffff;
      border-radius: 12px;
      box-shadow: 0 8px 24px rgba(23, 33, 94, 0.12);
      box-sizing: content-box;
      // 圆角裁剪：hover 背景为矩形，不裁剪的话首尾两项的角会超出面板弧线
      overflow: hidden;

      .nav-drop-item {
        height: 44px;
        line-height: 44px;
        padding: 0 24px;
        font-size: 15px;
        color: #1D1F24;
        cursor: pointer;

        &:hover {
          color: #3772FF;
          background: #f5f8ff;
        }
      }

      .nav-drop-item-active {
        color: #3772FF;
      }
    }
  }

  .nav-drop:hover .nav-drop-tri {
    transform: rotate(180deg);
  }





  a:first-child {
    padding: 0;
    margin-right: 20px;
    .logo {
      margin-top: 18px;
      width: 140px;
      height: 32px;
    }
  }


  .download-btn{
    float: right;
    margin-left: 32px;
    margin-top: 15px;
    padding-left: 20px;
    padding-right: 20px;
    height: 40px;
    line-height: 40px;
    text-align: center;
    background-color: #3772FF;
    border-radius: 6px;
    font-size: 16px;
    color: #FFFFFF !important;
    font-weight: 500;
  }
  .download-btn:hover{
    color: #FFFFFF;
    opacity: 0.9;
  }
    .console-btn{
        float: right;
    }




}
.bg1 {
  background: rgba(255, 255, 255, 0.9);
}
    .nav-for-homepage{
        border-bottom: none;
        background: transparent;
        backdrop-filter: none;
        .nav-for-homepage-a{
            color: #fff;
        }
        // 场景功能下拉链接：首页深色背景需白字（与 .nav-drop-link 特定度同级，靠后声明覆盖）
        .nav-drop {
            .nav-drop-link {
                color: #fff;
                &:hover {
                    color: #3772FF;
                }
            }
        }
    }
</style>

